const REVIEW_BASE_URL = 'https://reviews.decathlon.com/pt_BR/decathlon_model'

export const REVIEW_INVALID_CODE_MESSAGE =
  'Não foi possível identificar o produto para esta avaliação.'

/**
 * Builds the United (openvoice) review form URL for a given product code.
 *
 * Kept as a single source of truth because this path has changed before
 * (see commit 90defe865) and is duplicated across the standalone review
 * page, the PDP and account review CTAs.
 */
export function getReviewUrl(code: string) {
  const normalizedCode = encodeURIComponent(code.trim())

  return `${REVIEW_BASE_URL}/${normalizedCode}`
}

export function hasValidReviewCode(code?: string | null): code is string {
  return typeof code === 'string' && code.trim().length > 0
}
